import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
// components
import ContentLayout from "@/layouts/ContentLayout";
import TextBlock from "@/components/blocks/TextBlock";

// i18n
import { useTranslation } from "react-i18next";
import moment from "moment";

import blog1 from "@/assets/images/blog/michael-CPD-cert.png";
import blog2 from "@/assets/images/blog/thomson-CPD-cert.png";
import blog3 from "@/assets/images/blog/blog4.png";
import blog4 from "@/assets/images/blog/blog5.png";
import blog5 from "@/assets/images/blog/blog3.png";

interface Blog {
  id: string;
  title: string;
  category: string;
  date: string;
  descriptions: string[];
  images: string[];
}

const BlogDetail = () => {
  const { id } = useParams();
  const { i18n } = useTranslation();
  const [blog, setBlog] = useState<Blog | null>(null);

  useEffect(() => {
    // Dynamic import based on language
    import(`@/assets/blogs/${i18n.language.toLowerCase()}.json`)
      .then((module) => {
        setBlog(module.default.find((blog: Blog) => blog.id === id) || null);
      })
      .catch((error) => {
        // Fallback to English if translation doesn't exist
        import("@/assets/blogs/en.json").then((module) => {
          setBlog(module.default.find((blog: Blog) => blog.id === id) || null);
        });
      });
  }, [i18n.language]);

  const images = [blog3, blog4, blog5, blog1, blog2];

  return (
    <div className="w-full">
      <ContentLayout>
        <h1 className="mb-3 text-2xl font-extrabold leading-9 text-primary">{blog?.title}</h1>
        <div className="mb-6">
          <span className="text-sm font-semibold">{blog?.category}</span>
          <span className="mx-3"> | </span>
          <span className="text-sm font-normal">{blog?.date}</span>
        </div>
        <section className="flex w-full items-center justify-center">
          <Carousel className="max-w-[800px]" showStatus={false}>
            {images.map((image, index) => (
              <div key={index}>
                <img src={image} alt={`Blog image ${index + 1}`} />
              </div>
            ))}
          </Carousel>
        </section>
        <article className="flex w-full flex-col gap-3">
          {blog?.descriptions.map((description, index) => (
            <p key={index} className="text-sm font-normal leading-[30px]">
              {description}
            </p>
          ))}
        </article>
      </ContentLayout>
    </div>
  );
};

export default BlogDetail;
